import { Link } from "react-router-dom";
import { Sparkles, Heart } from "lucide-react";

export default function About() {
  return (
    <>
      <section className="container-edge py-20 grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-7">
          <div className="eyebrow mb-3"><Sparkles size={14} className="fill-coral" /> Our Story</div>
          <h1 className="display-serif text-5xl sm:text-6xl leading-[0.98]">
            We started KNV to <span className="hand-accent text-coral">change</span> the way groups travel.
          </h1>
          <div className="mt-10 space-y-6 text-muted2 leading-relaxed max-w-xl">
            <p>
              KNV Travelz was founded to do two things really well: design <strong className="text-ink">college tours</strong> that
              actually open doors for students, and run <strong className="text-ink">group travel for 25 or more</strong> to the dream
              destinations our travelers had been talking about for years.
            </p>
            <p>
              We specialize in HBCU tours across the country — Morehouse, Spelman, Clark Atlanta, Tuskegee,
              Howard University, Norfolk State, Hampton — and we also run mainstream college tours and
              one-day tours for groups not ready to take students overnight.
            </p>
            <p>
              On the group travel side, we plan everything from European capitals to Caribbean takeovers
              for community groups, alumni associations, churches, and family reunions. We're small on
              purpose — the people you talk to on the phone are the same people building your itinerary
              and running your trip.
            </p>
          </div>
        </div>
        <div className="col-span-12 md:col-span-5">
          <div className="relative">
            <img
              src="/brand/knv-team.jpg"
              alt="KNV Travelz team on the road"
              className="w-full h-[640px] object-cover rounded-[2rem] tilt-r"
            />
            <div className="absolute -bottom-4 -left-4 bg-sun rounded-2xl px-5 py-3 font-hand text-2xl text-ink tilt-l shadow-lg">
              we got you ✦
            </div>
          </div>
        </div>
      </section>

      <section className="bg-teal/8 py-20">
        <div className="container-edge grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            { k: "Educator-led design", v: "Itineraries built around classroom goals — not generic tourist routes." },
            { k: "Logistics-obsessed", v: "Group lodging blocks, dietary needs, late-bus contingencies — handled." },
            { k: "Real humans, every step", v: "The same KNV team plans, coordinates, and travels with your group." },
          ].map((b) => (
            <div key={b.k} className="bg-white rounded-3xl p-8 ring-1 ring-ink/8">
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-coralDeep mb-3">{b.k}</div>
              <p className="display-serif text-2xl leading-snug">{b.v}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-edge py-20 text-center">
        <Heart size={40} className="text-coral fill-coral mx-auto mb-5" />
        <h2 className="display-serif text-4xl sm:text-5xl mb-5">
          Ready to plan something? <span className="hand-accent text-coral">Let's go.</span>
        </h2>
        <p className="text-muted2 max-w-xl mx-auto mb-8">
          Got a group of 25 or more? Drop us your basics — we'll be back in two business days.
        </p>
        <Link to="/request-quote" className="btn-primary">Plan My Trip</Link>
      </section>
    </>
  );
}
